import { BehaviorSubject } from 'rxjs';
import { MasterHelper } from '../../utilities';
import { RegulationDetail } from './regulation-detail';
import { RegulationStatusInfoModel } from './regulation-status-info-model';

export class RegulationModel {
  id: number;
  libraryName:string;
  geography: string;
  country: string;
  mappingID: string;
  regulator: string;
  date: string;
  pubType: string;
  title: string;
  title1: string;
  ruleBookName: string;
  description: string;
  hyperlink: string;
  ruleTopic: string;
  linkedRules: string;
  linkedRulesByRegulator: string;
  linkedPolicies: string;
  linkedRisks: string;
  linkedProcesses: string;
  linkedRulesFlag: number;
  status: string;
  comment: string;
  isMoved: boolean;
  isRead: boolean;
  applicable: boolean;
  operative: boolean;
  isGreaterThanTodayDate: boolean;
  previousVersions!: any[];
  regulationDetails: RegulationDetail;
  impactAssessmentStatus: string;
  jurisdiction: string;
  similarityIndex: string;
  nlpRuleTopic: string;
  staticLibraryRuleTopic: string;
  staticLibraryComment: string;
  updatedBy: string;
  closedRegulationUsers!: string[];
  impactAssessmentUsers!: string[];
  currentActions: RegulationStatusInfoModel[];
  isRowBold: boolean;
  isManual!: boolean;
  tooltip: string;
  clientTopics: string
  title2: string;
  title3: string;
  title4: string;
  title5: string;
  ruleId:string;
  obligation:string;
  risks:string;
  controls:string;
  summary!: string;
  owner:string;
  part:string;
  isAssessed:boolean;
  isClosed:boolean;
  instruction:boolean;
  connections:string;
  appliesAcross:string;
  interpretation:string;
  linkedControls:string;
  userVersion:number;
  spiderLinks:string;
  relatedProvisions:string;

  constructor() {
    this.id = 0;
    this.libraryName = '';
    this.geography = '';
    this.country = '';
    this.mappingID = '';
    this.regulator = '';
    this.date = MasterHelper.getCurrrentDateTime('MM/DD/YYYY');
    this.pubType = '';
    this.title = '';
    this.title1 = '';
    this.ruleBookName = '';
    this.description = '';
    this.hyperlink = '';
    this.ruleTopic = '';
    this.linkedRules = '';
    this.linkedRulesByRegulator = '';
    this.linkedRulesFlag = 0;
    this.linkedPolicies = '';
    this.linkedRisks = '';
    this.linkedProcesses = '';
    this.linkedRulesFlag = 0;
    this.status = '';
    this.comment = '';
    this.isMoved = false;
    this.isRead = false;
    this.applicable = false;
    this.operative = false;
    this.isGreaterThanTodayDate = false;
    this.previousVersions = [];
    this.regulationDetails = new RegulationDetail();
    this.impactAssessmentStatus = '';
    this.jurisdiction = '';
    this.similarityIndex = '';
    this.nlpRuleTopic = '';
    this.staticLibraryRuleTopic = '';
    this.staticLibraryComment = '';
    this.updatedBy = '';
    this.closedRegulationUsers = [];
    this.impactAssessmentUsers = [];
    this.currentActions = [];
    this.isRowBold = true;
    this.tooltip = "";
    this.clientTopics = '';
    this.title2 = '';
    this.title3 = '';
    this.title4 = '';
    this.title5 = '';
    this.ruleId='';
    this.obligation='';
    this.risks='';
    this.controls='';
    this.owner='';
    this.part='';
    this.isAssessed = false;
    this.isClosed = false;
    this.instruction = false;
    this.connections = '';
    this.appliesAcross = '';
    this.interpretation = '';
    this.linkedControls = '';
    this.userVersion = 0;
    this.spiderLinks = '';
    this.relatedProvisions = '';
  }
}

export class RegulationFilterViewModel {
  Id: number;
  Geography: string;
  Country: string;
  MappingID: string;
  Regulator: string;
  Date: string;
  PubType: string[];
  Title: string[];
  Description: string[];
  Hyperlink: string;
  RuleTopic: string[];
  LinkedRules: string[];
  LinkedRulesByRegulator: string;
  LinkedPolicies: string;
  LinkedRisks: string;
  LinkedProcesses: string;
  LinkedRulesFlag: number;
  Status: string;
  IsMoved: boolean;
  PreviousVersions: any[];

  constructor() {
    this.Id = 0;
    this.Geography = '';
    this.Country = '';
    this.MappingID = '';
    this.Regulator = '';
    this.Date = MasterHelper.getCurrrentDateTime('MM/DD/YYYY');
    this.PubType = [];
    this.Title = [];
    this.Description = [];
    this.Hyperlink = '';
    this.RuleTopic = [];
    this.LinkedRules = [];
    this.LinkedRulesByRegulator = '';
    this.LinkedRulesFlag = 0;
    this.LinkedPolicies = '';
    this.LinkedRisks = '';
    this.LinkedProcesses = '';
    this.LinkedRulesFlag = 0;
    this.Status = '';
    this.IsMoved = false;
    this.PreviousVersions = [];
  }
}

export class RegulationViewModel {
  data: RegulationModel[];
  groupedData: any;
  totalCount: number;

  constructor() {
    this.data = new Array<RegulationModel>();
    this.totalCount = 0;
  }
}

export class GroupingRegulationViewModel {
  groupByColumnData!: string;
  otherDataSummary!: string;
  totalCount!: number;
}

export class LinkedRule {
  Country: string;
  Regulator: string;
  Title: string;

  constructor() {
    this.Country = '';
    this.Regulator = '';
    this.Title = '';
  }
}

export class LinkedPolicy {
  Id: number;
  Name: string;
  Type: string;
  Owner: string;
  LineOfBusiness: string;
  Functions: string;
  Locations: string;

  // tslint:disable-next-line:max-line-length
  constructor(id: number = 0, name: string = '', type: string = '', owner: string = '', lineOfBusiness: string = '', functions: string = '', locations: string = '') {
    this.Id = id;
    this.Name = name;
    this.Type = type;
    this.Owner = owner;
    this.LineOfBusiness = lineOfBusiness;
    this.Functions = functions;
    this.Locations = locations;
  }
}

export class RegulationWrapper {
  regulationData: RegulationModel;
  screenUrl: string;

  constructor() {
    this.regulationData = new RegulationModel();
    this.screenUrl = '';
  }
}


export class TableSortModel {
  SortKey: string;
  IsDesc: boolean;

  constructor() {
    this.SortKey = '';
    this.IsDesc = false;
  }
}

export class RegulationDataModel {
  id: number;
  libraryId: number;
  regulations: RegulationModel[];
  filterType: string;
  similarIndex: string;

  constructor() {
    this.id = 0;
    this.libraryId = 0;
    this.regulations = [];
    this.filterType = '';
    this.similarIndex = '';
  }
}

export class RegulationResultModel {
  data: BehaviorSubject<RegulationModel[]>;
  totalCount: number;

  constructor() {
    this.data = new BehaviorSubject<RegulationModel[]>([]);
    this.totalCount = 0;
  }
}
export class RegulationDescription{
  description:string;
  constructor(){
    this.description='';
  }
}
